export default __webpack_public_path__ + "static/media/4c.9ef6aa59.png";